import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import { Organisation } from "src/app/models/organisation";
import { User } from "src/app/models/user";
import { AllPatient } from "src/app/models/patient";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  Validators,
  UntypedFormGroup,
  UntypedFormBuilder,
  AbstractControlOptions,
  FormGroup,
  FormControl,
} from "@angular/forms";
import { ConfirmedValidator } from "src/app/common/passwordValidator";
import { formatDate } from "@angular/common";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: "app-create-account",
  templateUrl: "./create-account.component.html",
  styleUrls: ["./create-account.component.css"],
})
export class CreateAccountComponent implements OnInit {
  termsUrl = Utils.termsUrl;
  user = new User();
  patient = new AllPatient();
  editUser: string;
  dataValue2: any;
  innerHtml: string = "";
  emailpat = Utils.emailpat_withNoPlus;
  step: number = 1;
  organisation = new Organisation();
  zipRegex = Utils.zipRegex;
  passwordRegex = Utils.passwordRegex;
  currentLogin: string = "patientSignUp";
  gender = Utils.GENDER;
  maxDate = Utils.today;
  minDate = Utils.minDobDate;
  patientForm: UntypedFormGroup;
  validOTP: boolean = false;
  phone: any;
  termsAndCondition: boolean = false;
  wrongOTP: boolean = false;
  isMutePass: boolean = false;
  isMutePass2: boolean = false;
  disableCheckbok: boolean;
  currentDate = Utils.maxDate;
  miniDate = Utils.miniDate;
  constructor(
    private service: VproService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private _formBuilder: UntypedFormBuilder,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    if (this.router.url === "/info-basic") {
      this.step = 2;
    }

    this.patientForm = this._formBuilder.group(
      {
        first_name: [
          "",
          [
            Validators.required,
            Validators.maxLength(30),
            Validators.pattern(Utils.alphaSpaceRegex),
          ],
        ],
        last_name: [
          "",
          [
            Validators.required,
            Validators.maxLength(30),
            Validators.pattern(Utils.alphaSpaceRegex),
          ],
        ],
        dob: ["", [Validators.required]],
        email_id: [
          "",
          [
            Validators.required,
            Validators.maxLength(50),
            Validators.pattern(Utils.emailpat),
          ],
        ],
        confirm_email: [
          null,
          Validators.compose([Validators.required, , Validators.maxLength(50)]),
        ],
        gender: ["", [Validators.required]],
        contact_no: [
          "",
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.minLength(10),
            Validators.pattern(Utils.numberRegex),
          ],
        ],
        otp: ["", Validators.required],
      },
      {
        validator: ConfirmedValidator("email_id", "confirm_email"),
      } as AbstractControlOptions
    );
  }

  signUpUser(e: string): void {
    this.currentLogin = e;
  }

  tacChecked(evt) {
    let target = evt.target;
    this.termsAndCondition = target.checked;
  }

  public createAdminProfile(): void {
    this.user.first_name =
      (this.user.first_name.charAt(0).toUpperCase() +
        this.user.first_name.slice(1).toLowerCase()).trim();
    this.user.last_name =
      (this.user.last_name.charAt(0).toUpperCase() +
        this.user.last_name.slice(1).toLowerCase()).trim();
    if (this.user && this.user.email_id)
      this.user.email_id = (this.user.email_id.toLowerCase()).trim();

    this.user.account_type = Utils.ALLOWED_TYPE.ADMIN;
    this.spinner.show();
    this.service.addUser(this.user).subscribe(
      (res) => {
        // Set localstorage items
        localStorage.setItem("usethis", this.user.email_id);
        sessionStorage.setItem("fname", this.user.first_name);
        sessionStorage.setItem("lname", this.user.last_name);
        //this.step = 2;
        // this.organisation.usereid = this.user.email_id;
        console.log("USER DATA:::", this.user);
        // Shoot a mail to user
        this.service.mailUser(this.user).subscribe(
          (res) => {
            this.spinner.hide();
            // SweetAlert
            Swal.fire({
              allowOutsideClick: false,
              position: "top",
              type: "success",
              title:
                "User has been created successfully. Check your email for account activation.",
              showConfirmButton: false,
              timer: 3000,
            });
            this.router.navigate(["/login"]);
          },
          (error) => {
            this.spinner.hide();
            // SweetAlert
            Swal.fire({
              allowOutsideClick: false,
              position: "top",
              type: "error",
              title: "Something went wrong. Please try again later.",
              showConfirmButton: false,
              timer: 2500,
            });
          }
        );
      },
      (error) => {
        // console.log(error);
        this.spinner.hide();
        // SweetAlert
        Swal.fire({
          allowOutsideClick: false,
          position: "top",
          type: "error",
          title: "Something went wrong. Please try again later.",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    );
  }

  createPatientProfile() {
    let data = { ...this.patientForm.value };
    if (data.first_name && data.last_name) {
      data.first_name =
        (data.first_name.charAt(0).toUpperCase() +
          data.first_name.slice(1).toLowerCase()).trim();
      data.last_name =
        (data.last_name.charAt(0).toUpperCase() +
          data.last_name.slice(1).toLowerCase()).trim();
    }

    if (data.email_id) {
      data.email_id = (data.email_id.toLowerCase()).trim();
    }
    if (data.dob) {
      // data.dob = formatDate(data.dob, "yyyy-MM-dd", "en-US");
      data.dob = data.dob.year + "-" + data.dob.month + "-" + data.dob.day
    }
    data.account_type = Utils.ALLOWED_TYPE.PATIENT;
    data.contact_no = this.phone;
    data = Utils.removeNullAndEmpty(data);
    if (data.confirm_email) delete data.confirm_email;
    this.spinner.show();
    this.service.addUser(data).subscribe(
      (res) => {
        this.spinner.hide();
        //SweetAlert of Success
        Swal.fire({
          allowOutsideClick: false,
          position: "top",
          type: "success",
          title:
            "Patient has been created successfully. Check your email for account activation.",
          showConfirmButton: false,
          timer: 6000,
        });
        this.router.navigate(["/login"]);
      },
      (error) => {
        this.spinner.hide();
        // SweetAlert
        Swal.fire({
          allowOutsideClick: false,
          position: "top",
          type: "error",
          title:
            error && error.error && error.error.error
              ? error.error.error
              : "Something went wrong. Please try again later.",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    );
  }

  emailvalid(content) {
    console.log("email valid start")
    if (this.patientForm.value.confirm_email) {
      this.spinner.show();
      // this.service.fetchAllPatients(email_id: this.patientForm.value.email_id,).subscribe(
      this.service.emailvaild({ email_id: this.patientForm.value.confirm_email, relation: 'self' }).subscribe(
        (res) => {
          console.log("res", res)
          this.spinner.hide();
          this.showToast('success', "Welcome To ReliableDRS");
          this.disableCheckbok = false
        },
        (error) => {
          this.spinner.hide();

          this.modalService.open(content, { centered: true }).result.then(
            (result) => {
              console.log("result", result);

            },
            (reason) => {
              console.log("reason", reason);

              this.disableCheckbok = true;
            }
          );
        }
      );

    }
  }

  checkEid() {
    try {
      this.spinner.show();
      this.service.authUser2(this.user).subscribe(
        (data) => {
          this.spinner.hide();
          this.dataValue2 = data["utype"];

          if (this.dataValue2 !== 8) {
            this.innerHtml = `<div class="text-danger">*This email-id is already registered with us, please use another!</div>`;

            document.getElementById("email_id").focus();
          } else {
            this.innerHtml = "";

            document.getElementById("email_id").blur();
          }
        },
        (error) => {
          this.spinner.hide();
        }
      );
    } catch (excep) {
      // console.log(excep);
    }
  }

  public addOrg(): void {
    this.spinner.show();
    this.organisation.usereid =
      localStorage.getItem("usethis") || localStorage.getItem("LogUsr");
    this.service.addOrg(this.organisation).subscribe(
      (res) => {
        this.spinner.hide();
        // SweetAlert
        Swal.fire({
          position: "top",
          type: "success",
          title: "Account has been created successfully.",
          showConfirmButton: false,
          timer: 3000,
        });
        this.router.navigate(["/login"]);
      },
      (error) => {
        // console.log(error);
        this.spinner.hide();
        // SweetAlert
        Swal.fire({
          allowOutsideClick: false,
          position: "top",
          type: "error",
          title: "Something went wrong. Please try again later.",
          showConfirmButton: false,
          timer: 2500,
        });
      }
    );
  }

  requestOTP() {
    if (this.patientForm.value.contact_no) {
      //let contact_no =
      if (this.patientForm.value.otp) return;

      if (
        !this.patientForm.value.contact_no.match(Utils.numberRegex) ||
        this.patientForm.value.contact_no.length != 10
      ) {
        this.showToast(
          "error",
          "Invalid Contact No, Please enter a valid contact number"
        );
        this.patientForm.controls["contact_no"].reset();
        return;
      }
      this.spinner.show();
      this.service
        .requestOTP({ contact_no: this.patientForm.value.contact_no })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.showToast("success", res.message);
          },
          (error) => {
            // console.log(error);
            this.spinner.hide();
            this.showToast("error", "Something went wrong. Please try again.");
          }
        );
    }
  }

  validateOTP() {
    if (this.validOTP) return;
    if (this.patientForm.value.contact_no && this.patientForm.value.otp) {
      this.spinner.show();
      this.service
        .validateOTP({
          contact_no: this.patientForm.value.contact_no,
          otp: this.patientForm.value.otp,
        })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.showToast("success", res.message);
            this.otpValidated();
          },
          (err) => {
            // console.log(err);
            this.spinner.hide();
            let message =
              err && err.error && err.error.message && err.error.message.message
                ? err.error.message.message
                : "Something wrong. Couldn't delete appointment.";
            this.showToast("error", message);
            if (err.error.message.message) {
              this.wrongOTP = true;
              return;
            }
          }
        );
    }
  }

  otpValidated() {
    this.wrongOTP = false;
    this.phone = this.patientForm.value.contact_no;
    this.patientForm.controls["contact_no"].disable();
    this.patientForm.controls["otp"].disable();
    this.validOTP = true;
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }
}
